import { graphql } from "~/gql";

export const GET_PHASE = graphql(/* GraphQL */ `
  query GetPhase($phaseId: Float!) {
    getPhase(phaseId: $phaseId) {
      ...PhaseParts
    }
  }
`);
